export const borders = {
  none: "none",
  thin: "0.0625rem solid",
  medium: "0.125rem solid",
  thick: "0.25rem solid",
  dashed: "0.0625rem dashed"
};
